import { CompanyDefaultUnitOfMeasurement, FieldGroupEnum, OrderStatus, OrderType } from "@/graphql/codegen/graphql"
import type { Option } from "@/types/form-fields"

export enum POActionNames {
  Print = "Print",
  Download = "Download",
  Clone = "Clone",
  CancelPO = "Cancel PO",
  CancelQuote = "Cancel Quote",
  OriginalPO = "Original PO",
  AbandonChanges = "Abandon Changes",
  SaveDraft = "Save Draft",
  SaveQuote = "Save Quote",
  SaveAndExit = "Save and Exit",
  Exit = "Exit",
  Preview = "Preview",
  RequestQuote = "Request Quote",
  ReRequestQuote = "Re-Request Quote",
  Send = "Send PO",
  ReSend = "Re-Send PO",
}

export const NOT_AVAILABLE_STATUS_TO_UPDATE = [
  OrderStatus.Draft,
  OrderStatus.Quote,
  OrderStatus.Cancelled,
  OrderStatus.Completed,
]

export const PO_EMAIL_SUBSCRIPTION_TYPES: Record<OrderType.Quote | OrderType.PurchaseOrder, string[]> = {
  QUOTE: [OrderType.Quote],
  PURCHASE_ORDER: [OrderType.PurchaseOrder],
}

export const PURCHASE_ORDER_DOCUMENT_TYPE_TO_LABEL = new Map<FieldGroupEnum, string>([
  [FieldGroupEnum.PurchaseOrderAsn, "ASN (Advance Shipping Notice)"],
  [FieldGroupEnum.PurchaseOrderBillOfLanding, "Bill of Lading"],
  [FieldGroupEnum.PurchaseOrderBrokerDoc, "Broker Documentation"],
  [FieldGroupEnum.PurchaseOrderOriginCert, "Certificate of Origin"],
  [FieldGroupEnum.PurchaseOrderCoa, "COA (Certificate of Analysis)"],
  [FieldGroupEnum.PurchaseOrderCommercialDoc, "Commercial Documents"],
  [FieldGroupEnum.PurchaseOrderConfirmation, "Confirmation"],
  [FieldGroupEnum.PurchaseOrderDangerousGoodsDeclaration, "Dangerous Goods Declaration"],
  [FieldGroupEnum.PurchaseOrderDeliveryDocs, "Delivery Docs"],
  [FieldGroupEnum.PurchaseOrderEntrySummary, "Entry Summary"],
  [FieldGroupEnum.PurchaseOrderFumigationCert, "Fumigation Certificate"],
  [FieldGroupEnum.PurchaseOrderHeatTreatmentCert, "Heat Treatment Certificate"],
  [FieldGroupEnum.PurchaseOrderIsf, "ISF (Importer Security File)"],
  [FieldGroupEnum.PurchaseOrderLogisticsInvoice, "Logistics Invoice"],
  [FieldGroupEnum.Miscellaneous, "Miscellaneous"],
  [FieldGroupEnum.PurchaseOrderPackingList, "Packing List"],
  [FieldGroupEnum.PurchaseOrderPreShipSample, "Pre-Ship Sample"],
  [FieldGroupEnum.PurchaseOrderVendorInvoice, "Vendor Invoice"],
])

export const PURCHASE_ORDER_DOCUMENT_TYPE_OPTIONS: Option<FieldGroupEnum>[] = Array.from(
  PURCHASE_ORDER_DOCUMENT_TYPE_TO_LABEL,
  ([value, label]) => ({ value, label })
)

export const PURCHASE_ORDER_STATUS_OPTIONS = new Map<OrderStatus, string>([
  [OrderStatus.Cancelled, "Cancelled"],
  [OrderStatus.CanceledQuote, "Cancelled Quote"],
  [OrderStatus.Quote, "Quote"],
  [OrderStatus.Shipped, "Shipped"],
  [OrderStatus.Completed, "Completed"],
  [OrderStatus.Confirmed, "Confirmed"],
  [OrderStatus.PartiallyReceived, "Partially Received"],
  [OrderStatus.PartiallyShipped, "Partially Shipped"],
  [OrderStatus.Received, "Received"],
  [OrderStatus.Sent, "Sent"],
])

/**
 * Defines allowed status transitions for each order status.
 * If a status is not in this map, it uses all statuses from PURCHASE_ORDER_STATUS_OPTIONS
 * except Quote and CanceledQuote.
 */
export const PURCHASE_ORDER_STATUS_TRANSITIONS = new Map<OrderStatus, OrderStatus[]>([
  // Cancelled Quote can transition back to Quote or remain Cancelled Quote
  [OrderStatus.CanceledQuote, [OrderStatus.Quote, OrderStatus.CanceledQuote]],
])

export const BLANK_PURCHASE_ORDER_SHIP_TO = ""

export const UOMS_ORDER = [
  CompanyDefaultUnitOfMeasurement.UsstdWeightShortTon,
  CompanyDefaultUnitOfMeasurement.UsstdWeightPound,
  CompanyDefaultUnitOfMeasurement.MetricWeightTon,
  CompanyDefaultUnitOfMeasurement.MetricWeightKilogram,
]
